import { getPageLayoutOption, pageHasRoom } from '../../lib/comicPageLayout'
import type { ComicPage, ComicPanel } from '../../lib/comicTypes'
import { ChromePrimaryButton, ChromeToolbarButton } from '../ChromeActions'
import { managementListActionClass } from '../ManagementListModal'
import { ManagementListBody } from '../ManagementListModal'
import { ThemeModal } from '../modal'

type Props = {
  open: boolean
  angular: boolean
  panel: ComicPanel | null
  pages: ComicPage[]
  currentPageId: string | null
  onClose: () => void
  onMove: (targetPageId: string) => void
}

function targetCountWithoutPanel(page: ComicPage, panelId: string): number {
  return page.panelIds.filter((id) => id !== panelId).length
}

export function ComicPanelPageMapModal({
  open,
  angular,
  panel,
  pages,
  currentPageId,
  onClose,
  onMove,
}: Props) {
  const panelId = panel?.id ?? null

  const entries = pages.map((page) => {
    const onCurrent = page.id === currentPageId
    const countAfter = panelId ? targetCountWithoutPanel(page, panelId) : page.panelIds.length
    const canMove = panelId != null && pageHasRoom(page.layout, countAfter)
    const layoutLabel = getPageLayoutOption(page.layout).label

    return {
      id: page.id,
      primary: page.title,
      badge: onCurrent ? '当前页' : undefined,
      detail: `${layoutLabel} · ${countAfter}/${getPageLayoutOption(page.layout).maxPanels} 格`,
      actions: (
        <ChromeToolbarButton
          type="button"
          className={managementListActionClass(angular)}
          disabled={!canMove}
          onClick={() => {
            if (!canMove) return
            onMove(page.id)
            onClose()
          }}
        >
          {canMove ? '移入' : '已满'}
        </ChromeToolbarButton>
      ),
    }
  })

  return (
    <ThemeModal
      open={open}
      onClose={onClose}
      title="映射分页"
      angular={angular}
      size="md"
      bodyClassName="px-4 py-4 sm:px-5 sm:py-5"
      footer={
        <div className="flex justify-end">
          <ChromePrimaryButton density="compact" type="button" onClick={onClose}>
            取消
          </ChromePrimaryButton>
        </div>
      }
    >
      <ManagementListBody entries={entries} angular={angular} emptyText="暂无分页" />
    </ThemeModal>
  )
}
